import * as React from 'react';
import styled from 'styled-components';

const HighlightLeafMain = styled.mark`
  background-color: rgba(255, 196, 106, 0.4);
`;

export const HighlightLeaf = ({ attributes, children, className }) => {
  return (
    <HighlightLeafMain {...attributes} className={className}>
      {children}
    </HighlightLeafMain>
  );
};
